const rulesData = {
  /* 主食 */
  staple: [
    {
      title: '食材',
      list: [
        {
          title: '优选食材（100分）',
          type: 'green',
          desc: '粗杂粮类、薯类、杂豆类',
          data: [
            '1. 食材推荐表中的红榜食材',
            '2. 浓稠的杂粮粥、小米粥',
            '3. 粗细搭配的主食，比如：一半粗粮一半细粮',
            '4. 没有粗杂粮时选择的白米饭',
            '5. 配料表干净的粗粮制品（达人直播间推荐的相关产品：全麦面包（欧包、吐司）、荞麦面、意面、杂粮馒头、粗粮水饺等），食用频次控制在每周3-4次'
          ]
        },
        {
          title: '次选主食（-30分）',
          type: 'yellow',
          desc: '',
          data: [
            '1. 配料表干净的粗粮制品（达人直播间推荐的相关产品：全麦面包（欧包、吐司）、荞麦面、意面、杂粮馒头、粗粮水饺等）食用频次次超过4次',
            '2. 藕粉、葛根粉等'
          ]
        },
        {
          title: '不推荐主食（-40分）',
          type: 'red',
          desc: '',
          data: ['1. 精细主食~精致碳水类', '2. 食材推荐表中的黑榜食材']
        },
        {
          title: '无主食（-100分）',
          type: 'red',
          desc: '',
          data: []
        }
      ]
    },
    {
      title: '分量',
      list: [
        {
          title: '适中（100分）',
          type: 'green',
          desc: '',
          data: []
        },
        {
          title: '偏多（-30分）',
          type: 'yellow',
          desc: '',
          data: []
        },
        {
          title: '偏少（-30分）',
          type: 'yellow',
          desc: '',
          data: []
        },
        {
          title: '份量不明确（-20分）',
          type: 'yellow',
          desc: '学员没有明确告知或者拍照她具体的餐卡份量',
          data: []
        }
      ]
    },
    {
      title: '烹饪方式',
      list: [
        {
          title: '烹饪方式健康（100分）',
          type: 'green',
          desc: '蒸、煮、焖、清炒、凉拌、微波炉、烤箱、空气炸锅',
          data: []
        },
        {
          title: '烹饪方式不健康（-20分）',
          type: 'red',
          desc: '高温油炸、爆炒、无油水煮菜等',
          data: []
        }
      ]
    }
  ],
  //蛋白质
  protein: [
    {
      title: '食材',
      list: [
        {
          title: '优选蛋白质（100分）',
          type: 'green',
          desc: '肉类，蛋类、水产品、乳酪品、血制品、大豆类',
          data: [
            '1. 食材推荐表中的红榜食材',
            '2. 去皮的鸡腿、鸭腿、去皮鸡中翅',
            '3. 配料表干净的乳酪制品',
            '4. 配料表干净的即食蛋白质食物，如鸡胸肉',
            '5. 一周2次的猪肝、鸡肝、鹅肝、鸡胗、鸭胗【需控制量，搭配其他蛋白质食物一起】',
            '6. 大豆制品：黄豆（浆）、黑豆（浆）、青豆（毛豆）',
            '7. 运动后的蛋白粉补充'
          ]
        },
        {
          title: '次选蛋白质（-30分）',
          type: 'yellow',
          desc: '',
          data: [
            '1. 配料较为干净的加工肉类（达人直播间推荐的相关产品）',
            '2. 五花肉、雪花牛肉',
            '3. 蛋白粉代替蛋白质食物',
            '4. 再制干酪',
            '5. 胶原蛋白、燕窝',
            '6. 阿胶',
            '7. 水浸金枪鱼罐头',
            '8. 皮蛋',
            '9. 未去皮鸡中翅'
          ]
        },
        {
          title: '不推荐蛋白质（-40分）',
          type: 'red',
          desc: '',
          data: [
            '1. 海鲜天妇罗、油浸肉/鱼罐头、肉松、蟹黄蟹膏',
            '2. 鸡翅尖、鸡翅、鸡爪、五花肉、腊肉/腊鱼、猪蹄、动物皮、肥肉、咸鸭蛋、虎皮蛋',
            '3. 腐乳、油豆皮、油面筋、油豆腐、豆瓣酱',
            '4. 市面上常见的香肠、培根、丸子、蟹棒、火腿肠',
            '5. 阿胶糕'
          ]
        },
        {
          title: '无蛋白质（-100分）',
          type: 'red',
          desc: '',
          data: []
        }
      ]
    },
    {
      title: '分量',
      list: [
        {
          title: '适中（100分）',
          type: 'green',
          desc: '',
          data: []
        },
        {
          title: '偏多（-30分）',
          type: 'yellow',
          desc: '',
          data: []
        },
        {
          title: '偏少（-30分）',
          type: 'yellow',
          desc: '',
          data: []
        },
        {
          title: '分量不明确（-20分）',
          type: 'yellow',
          desc: '学员没有明确告知或者拍照她具体的餐卡份量',
          data: []
        }
      ]
    },
    {
      title: '烹饪方式',
      list: [
        {
          title: '烹饪方式健康（100分）',
          type: 'green',
          desc: '蒸、煮、焖、清炒、凉拌、微波炉、烤箱、空气炸锅',
          data: []
        },
        {
          title: '烹饪方式不健康（-20分）',
          type: 'red',
          desc: '高温油炸、爆炒、无油水煮菜等',
          data: []
        }
      ]
    }
  ],
  /* 蔬菜 */
  vegetable: [
    {
      title: '食材',
      list: [
        {
          title: '优选蔬菜（100分）',
          type: 'green',
          desc: '叶菜类、瓜茄类、根菜类、菌菇类、海藻类、带豆荚的豆类、老南瓜、藕尖、玉米笋、银耳、绿豆芽、黄豆芽等都是蔬菜',
          data: []
        },
        {
          title: '次选蔬菜（-30分）',
          type: 'yellow',
          desc: '配料较为干净的蔬菜粉（达人直播间推荐的羽衣甘蓝、膳食纤维粉、脱水蔬菜等相关产品）',
          data: []
        },
        {
          title: '不推荐蔬菜（-40分）',
          type: 'red',
          desc: '腌制蔬菜、榨菜、酸菜、剁辣椒、腌制蔬菜',
          data: []
        },
        {
          title: '无蔬菜（-100分）',
          type: 'red',
          desc: '',
          data: []
        }
      ]
    },
    {
      title: '分量',
      list: [
        {
          title: '适中（100分）',
          type: 'green',
          desc: '',
          data: []
        },
        {
          title: '偏多（-30分）',
          type: 'yellow',
          desc: '',
          data: []
        },
        {
          title: '偏少（-30分）',
          type: 'yellow',
          desc: '',
          data: []
        },
        {
          title: '分量不明确（-20分）',
          type: 'yellow',
          desc: '学员没有明确告知或者拍照她具体的餐卡份量',
          data: []
        }
      ]
    },
    {
      title: '烹饪方式',
      list: [
        {
          title: '烹饪方式健康（100分）',
          type: 'green',
          desc: '蒸、煮、焖、清炒、凉拌、微波炉、烤箱、空气炸锅',
          data: []
        },
        {
          title: '烹饪方式不健康（-20分）',
          type: 'red',
          desc: '高温油炸、爆炒、无油水煮菜等',
          data: []
        }
      ]
    }
  ],
  //油脂
  grease: [
    {
      title: '食材',
      list: [
        {
          title: '推荐的食用油（100分）',
          type: 'green',
          desc: '',
          data: [
            '1. 食材推荐红榜的食用油种类',
            '2. 亚麻籽，奇亚籽',
            '3. 原味坚果类',
            '4. 牛油果',
            '5. 椰子油：可适当食用，多种推荐油脂替换食用，给与满分',
            '6. 早餐学员搭配没有油脂也给满分'
          ]
        },
        {
          title: '不推荐的食用油（-40分）',
          type: 'red',
          desc: '动物油、黄油、起酥油（如学员对于食用油种类学员没有描述，默认推荐）',
          data: []
        },
        {
          title: '无油脂（-100分）',
          type: 'red',
          desc: '',
          data: [
            '1. 中晚餐没有安排油脂。【早餐除外】',
            '2. 需注意牛油果、亚麻籽、坚果、油醋汁等这些都要算油脂'
          ]
        }
      ]
    },
    {
      title: '分量',
      list: [
        {
          title: '适中（100分）',
          type: 'green',
          desc: '',
          data: [
            '1. 早餐学员没有油脂的情况下，给满分，文字建议加餐可选择坚果或者中晚餐多一点油脂，整体一天控制在25-30克食用油',
            '2. 外食聚餐明确描述有过水或者餐卡图片展示有过水',
            '3. 肉眼所见油脂合适',
            '4. 需注意牛油果、亚麻籽、坚果、油醋汁等这些都要算油脂'
          ]
        },
        {
          title: '偏多（-30分）',
          type: 'yellow',
          desc: '',
          data: ['1. 肉眼看着饮食很油腻', '2. 烧烤等调味料比较多的饮食']
        },
        {
          title: '偏少（-30分）',
          type: 'yellow',
          desc: '',
          data: ['1. 中晚餐水煮菜、油脂很少的情况']
        }
      ]
    },
    {
      title: '烹饪方式',
      list: [
        {
          title: '烹饪方式健康（100分）',
          type: 'green',
          desc: '蒸、煮、焖、清炒、凉拌、微波炉、烤箱、空气炸锅',
          data: []
        },
        {
          title: '烹饪方式不健康（-20分）',
          type: 'yellow',
          desc: '高温油炸、爆炒、无油水煮菜等',
          data: []
        }
      ]
    }
  ],
  taste: [
    {
      title: '',
      list: [
        {
          title: '搭配合理（100分）',
          type: 'green',
          desc: '',
          data: [
            '1. 三要素齐全搭配标准',
            '2. 没有搭配减脂期间不推荐吃的食材',
            '3. 早餐圣女果替代蔬菜算合理'
          ]
        },
        {
          title: '搭配不合理（-50分）',
          type: 'red',
          desc: '',
          data: [
            '1. 正餐搭配水果、红枣枸杞等【圣女果除外】',
            '2. 搭配甜点零食：蛋糕、饼干、甜品、枣仁派、阿胶糕（加红枣和糖）、酒酿圆子等',
            '3. 搭配含糖饮料、奶茶、果茶等',
            '4. 明确表示有喝酒',
            '5. 学员选择的是代餐、搭配蛋白棒',
            '6. 食材单一【连续三天食材种类偏少且相同食材多】',
            '7. 混合优选、次选、不推荐食材',
            '8. 不明酱汁(三明治酱汁、汉堡酱汁等)',
            '注：文字点评需要明确告知扣分点并给与建议，可在【结束语/未来建议板块进行说明】'
          ]
        }
      ]
    }
  ]
}
export { rulesData }
